import React from "react";
import { observer, inject } from "mobx-react";
import { Refresh } from "@mui/icons-material";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

function LoginTimer(props) {
  const { timeLeft } = props.store;

  return (
    <div className="h-list">
      <Typography variant="caption">
        Nu ai primit cod? Asteapta <b>{timeLeft} sec.</b>
      </Typography>

      <Button
        color="primary"
        endIcon={<Refresh />}
        onClick={props.sendPhone}
      >
        Retrimite SMS
      </Button>
    </div>
  );
}

export default inject((stores) => ({ store: stores.mainStore }))(
  observer(LoginTimer)
);
